/**
 * RPC Config. See the guide for example.
 */
export class RxStompRPCConfig {
}
//# sourceMappingURL=rx-stomp-rpc-config.js.map